var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodVeryBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_50031)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.5627C17.2727 19.5809 15.6364 21.2173 13.6182 21.2173C11.6 21.2173 9.96362 19.5809 9.96362 17.5627C9.96362 15.5446 11.6 13.9082 13.6182 13.9082C15.6364 13.9082 17.2727 15.5446 17.2727 17.5627Z",
    fill: "#7C0EE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1272C18 19.1454 16.3636 20.7817 14.3455 20.7817C12.3273 20.7817 10.6909 19.1454 10.6909 17.1272C10.6909 15.109 12.3273 13.4727 14.3455 13.4727C16.3636 13.4727 18 15.109 18 17.1272Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0182 17.1278C16.0182 18.0551 15.2727 18.8005 14.3637 18.8005C13.4546 18.8005 12.7091 18.0551 12.7091 17.1278C12.7091 16.2005 13.4546 15.4551 14.3637 15.4551C15.2727 15.4733 16.0182 16.2187 16.0182 17.1278Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7272 16.3808C13.7272 16.799 13.3818 17.1445 12.9636 17.1445C12.5454 17.1445 12.2 16.799 12.2 16.3808C12.2 15.9626 12.5454 15.6172 12.9636 15.6172C13.4 15.6172 13.7272 15.9445 13.7272 16.3808Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4182 17.5629C29.4182 19.5811 27.7819 21.2174 25.7637 21.2174C23.7455 21.2174 22.1091 19.5811 22.1091 17.5629C22.1091 15.5447 23.7455 13.9084 25.7637 13.9084C27.8 13.8902 29.4182 15.5447 29.4182 17.5629Z",
    fill: "#7C0EE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.509 20.7817C28.5274 20.7817 30.1636 19.1456 30.1636 17.1272C30.1636 15.1089 28.5274 13.4727 26.509 13.4727C24.4907 13.4727 22.8545 15.1089 22.8545 17.1272C22.8545 19.1456 24.4907 20.7817 26.509 20.7817Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2727 17.1277C28.2727 18.0731 27.509 18.8549 26.5636 18.8549C25.6181 18.8549 24.8545 18.0913 24.8545 17.1277C24.8545 16.1822 25.6181 15.4004 26.5636 15.4004C27.509 15.4186 28.2727 16.1822 28.2727 17.1277Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9272 16.3463C25.9272 16.7826 25.5817 17.1281 25.1453 17.1281C24.709 17.1281 24.3635 16.7826 24.3635 16.3463C24.3635 15.9099 24.709 15.5645 25.1453 15.5645C25.5817 15.5645 25.9272 15.9099 25.9272 16.3463Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8363 16.0545C17.3818 14.5636 15.9818 13.4727 14.3454 13.4727C12.709 13.4727 11.3272 14.5636 10.8545 16.0545H17.8363Z",
    fill: "#B77CEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.0545C29.5455 14.5636 28.1455 13.4727 26.5091 13.4727C24.8727 13.4727 23.4909 14.5636 23.0182 16.0545H30Z",
    fill: "#B77CEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_50031)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.291 25.0871C32.291 27.3053 30.491 29.1235 28.2728 29.1235C26.0546 29.1235 24.2546 27.3235 24.2546 25.0871C24.2546 22.869 26.0546 21.0508 28.2728 21.0508C30.491 21.0508 32.291 22.8508 32.291 25.0871Z",
    fill: "url(#paint2_radial_40_50031)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 10.7634C12.7272 11.3089 11.8181 11.818 10.9817 12.4362C10.6544 12.6725 10.9635 13.218 11.2908 12.9816C12.1272 12.3634 13.0181 11.8544 13.909 11.3089C14.2544 11.0907 13.9453 10.5453 13.5999 10.7634Z",
    fill: "#7C0EE1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 10.2908C12.7272 10.8362 11.8181 11.3453 10.9817 11.9635C10.6544 12.1999 10.9635 12.7453 11.2908 12.509C12.1272 11.8908 13.0181 11.3817 13.909 10.8362C14.2544 10.6181 13.9453 10.0726 13.5999 10.2908Z",
    fill: "#14110E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6728 10.7634C27.5456 11.3089 28.4547 11.818 29.291 12.4362C29.6183 12.6725 29.3092 13.218 28.9819 12.9816C28.1456 12.3634 27.2547 11.8544 26.3638 11.3089C26.0183 11.0907 26.3274 10.5453 26.6728 10.7634Z",
    fill: "#7C0EE1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6728 10.2908C27.5456 10.8362 28.4547 11.3453 29.291 11.9635C29.6183 12.1999 29.3092 12.7453 28.9819 12.509C28.1456 11.8908 27.2547 11.3817 26.3638 10.8362C26.0183 10.6181 26.3274 10.0726 26.6728 10.2908Z",
    fill: "#14110E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 28.0918H24.8182",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_50031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#E0BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9938F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_50031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_50031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.276 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodVeryBad);
export default __webpack_public_path__ + "static/media/Mood_Very-Bad.525113235b12c969b4dc6b1f31088940.svg";
export { ForwardRef as ReactComponent };